import { useEffect, useState } from "react";
import ImageUploader2 from "./ImageUploader2";
import Resizer from "react-image-file-resizer";
import { Field, Form as FinalForm } from "react-final-form";
import Swal from "sweetalert2";
import axios from "axios";
import SelectBox from "./Select";


const AddOfferForm = (props) => {
  const {
    loadingCallback,
    navigate,
    setShowPaymentModal,
    setShowModal,
    isOpen,
    title,
    //setWarningMessage,
    type,
    formData,
    setFormData,
    refetch,
    getOfferList,
    brands
  } = props;

  const token = localStorage.getItem("token");

  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const [url, setUrl] = useState("");

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
    }
  };

  const handleUpload = async () => {
    if (!image) {
      alert("Please select an image first.");
      return;
    }

    console.log("Image File:", image);
    console.log("Type of Image:", typeof image);
    console.log("Is instance of File?", image instanceof File);

    const formImageData = new FormData();
    formImageData.append("file_name", image); // Appending the selected image file
    console.log("formImageData", formImageData);

    // Log each entry in FormData
    for (let pair of formImageData.entries()) {
      console.log(`Key: ${pair[0]}, Value:`, pair[1]);
    }

    try {
      // Step 1: Upload the image
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}file-upload`,
        formImageData,
        {
          headers: {
            authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Image uploaded successfully:", response.data.path);

      // Step 2: Update form data with the image URL received from the API
      const updatedFormData = {
        ...formData,
        image: response.data.path, // Save the image path in form data
      };

      // Step 3: Send the updated form data (including image URL) to save the offer
      const offerResponse = await axios.post(
        `${process.env.REACT_APP_API_URL}save-latest-offer`,
        updatedFormData,
        {
          headers: {
            authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Offer saved successfully:", offerResponse.data);

      // Step 4: Update UI states
      setImageUrl(response.data.path);
      getOfferList();
      alert("Image and offer saved successfully!");
      setShowModal(false);
    } catch (error) {
      console.error("Error in uploading image or saving offer:", error);
      alert("An error occurred. Please try again!");
    }
  };


  const handleChangeSelect = (name, option) => {
    const { value, label } = option;
    //console.log("option", option , "name", name);
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  return (
    <div className="duration-500 w-[3/4] h-[3/4]">
      <div className="w-full relative">
        <label className="absolute font-nunito text-xs text-[#102048] -top-[7px] left-[12px] bg-white px-1 font-semibold">
          Title
        </label>
        <input
          type="text"
          name="title"
          placeholder="Title"
          onChange={(e) =>
            setFormData({
              ...formData,
              title: e.target.value,
            })
          }
          className="input input-bordered border-[#C1CFEF] border-[1px] w-full mb-[10px] focus:outline-none rounded-xl bg-white"
        />
      </div>
      <div className="w-full relative">
        <label className="absolute font-nunito text-xs text-[#102048] -top-[7px] left-[12px] bg-white px-1 font-semibold">
          URL
        </label>
        <input
          type="text"
          name="url"
          placeholder="URL"
          onChange={(e) =>
            setFormData({
              ...formData,
              url: e.target.value,
            })
          }
          className="input input-bordered border-[#C1CFEF] border-[1px] w-full mb-[10px] focus:outline-none rounded-xl bg-white"
        />
      </div>
      <div className="flex flex-col ">
        <div className="w-full relative mt-2">
          <label className="absolute font-nunito text-xs text-[#102048]  left-[12px] top-[-7px] bg-white px-1 font-semibold">
            Description
          </label>
          <textarea
            type="text"
            name="description"
            onChange={(e) =>
              setFormData({
                ...formData,
                description: e.target.value,
              })
            }
            placeholder="Description"
            className="input input-bordered border-[#C1CFEF] border-[1px] focus:outline-none  w-full  h-20 pt-2 rounded-xl bg-white resize-none"
          />
        </div>


        <div className="flex flex-col ">
          <div className="w-full relative mt-2">
            <label className="absolute font-nunito text-xs text-[#102048]  left-[12px] top-[-7px] bg-white px-1 font-semibold z-50">
              Brand
            </label>
            <SelectBox
              name="brand_id"
              options={brands}
              value={formData.brand_id}
              onChange={handleChangeSelect.bind(this, "brand_id")}
              // error={formErrors.brand_id}
              // setFormErrors={setFormErrors}
              placeholder="Select Brand"
            />
          </div>
        </div>

        <div className="flex flex-col ">
          <div className="w-full relative mt-2">
            <div className="md:pl-3">
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
              />
              {image && (
                <img
                  src={URL.createObjectURL(image)}
                  alt="Preview"
                  className="w-32 h-32 mt-2"
                />
              )}
            </div>
          </div>
        </div>

        <div>
          <button
            onClick={() => handleUpload()}
            className="cursor-pointer w-full mt-4 bg-[#3559b3] hover:bg-[#034AFF] py-[17px] text-center rounded-2xl text-[#fff] font-lato font-semibold text-lg"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddOfferForm;
